<template>
  <div class="acDivider">
    <div class="acDivider_line"/>
    <div class="acDivider_text"><slot></slot></div>
    <div class="acDivider_line"/>
  </div>
</template>

<script lang="ts" setup>
defineOptions({
  name: 'AcDivider'
})
</script>

<style lang="scss">
  .acDivider {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: flex-start;
    overflow: hidden;

    &_line {
      height: 1px;
      background-color: var(--ac-color-light-gray);
      flex: 1 100%;
    }
    &_text {
      font-family: Inter;
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;

      margin: 0 6px;

      &:empty {
        display: none;
      }
    }
  }
</style>
